export function getPercentDifference(a: number, b: number): number {
  const difference = Math.abs(a - b);
  const max = Math.max(a, b);
  if (max === 0) return 0;
  return (difference / max) * 100;
}
